import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'rebass';
import { Label } from '@rebass/forms';
import moment from 'moment-timezone';
import services from 'services/services';
import helpers from 'utils/helpers';
import helpersStudy from 'utils/helpers-study';
import { CURRENCY_SYMBOL } from 'utils/constants';
import LoadingIndicator from 'components/LoadingIndicator';
import LoadingWrapper from 'components/LoadingIndicator/LoadingWrapper';
import { Editor } from 'draft-js';
import { FiClock } from 'react-icons/fi';

class PastParticipation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            person_id: this.props.person_id,
            person: this.props.person,
            loading: this.props.fetch_person == true ? true : false
        };
    }

    componentDidMount() {
        if (this.props.fetch_person == true) {
            this.getPersonXHR();
        }
    }

    getPersonXHR() {
        console.log('fetching person!')
        const { toastManager } = this.props;

        services
            .getPerson(this.props.person_id)
            .then(personResponse => {
                this.setState({
                    person: personResponse,
                    loading: false
                });
            })
            .catch(error => {
                console.log(error);
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    render() {

        if (this.state.loading) {
            return    <div style={{ width: '100%' }}>
                            <LoadingWrapper>
                                <LoadingIndicator />
                            </LoadingWrapper>
                            <br/>
                        </div>;
        }
                            

        const which_studies = [];

        if (this.state.person && this.state.person.study_person_all) {
            
            this.state.person.study_person_all.forEach(studyPerson => {
                //console.log('sssss', studyPerson, this.state.person)

                const study = this.state.person.studies.find(study => study.id == studyPerson.study_id);
                if (study) {
                    // check if paid
                    let paidAmount = 0;
                    if (studyPerson.incentive_status == 'paid') {
                        paidAmount = helpers.renderCurrencyAmount(studyPerson.incentive_currency, studyPerson.incentive_total_paid);
                    }
                    
                    which_studies.push(
                        <Box key={study.id} mb={3} p={3} fontSize={1} justifyContent='space-between' className='border'>
                            <Box><Link to={`/studies/${study.id}/participants/${studyPerson.id}`} className='muted'>{study.title}</Link></Box>
                            <Box fontSize={1}>
                                <Flex sx={{gridGap: 2}}>
                                    {studyPerson.status > 0 &&
                                        <Box mt={2}>
                                            <Label className='label-basic'>{helpersStudy.getHumanReadableSPStatus(studyPerson.status)}</Label>
                                        </Box>
                                    }
                                    {paidAmount ? (
                                        <Box mt={2}>
                                            <Label className='label-basic bg-green'>Paid {paidAmount}</Label>
                                        </Box>
                                    ) : ('')}

                                    {studyPerson.spot ? (
                                        <Box mt={2}>
                                            <Label className='label-basic'>
                                                <FiClock />
                                                {moment
                                                    .utc(studyPerson.spot)
                                                    .tz(studyPerson.timezone)
                                                    .format('MMM Do, YYYY [at] h:mma')}
                                            </Label>
                                        </Box>
                                    ) : ('')}
                                </Flex>

                                <small style={{color: '#999'}}>
                                    {studyPerson.created_at &&
                                        <Box mt={1}>
                                            Added on {moment
                                                .utc(studyPerson.created_at)
                                                .local()
                                                .format('MMM Do, YYYY')}
                                        </Box>
                                    }
                                    {studyPerson.emails_sent.map(es => {
                                        return <Box mt={1}>Email sent on {moment
                                                .utc(es.created_at)
                                                .local()
                                                .format('MMM Do, YYYY')}</Box>
                                    })}

                                    {studyPerson.screener_answers.map(sa => {
                                        return <Box mt={1}>Screener answered on {moment
                                                .utc(sa.created_at)
                                                .local()
                                                .format('MMM Do, YYYY')}</Box>
                                    })}
                               

                                    {studyPerson.notes && 
                                        <Box mt={2}>
                                            <Box className='blockquote-notes'>
                                                <Box mt={2}>Notes:</Box>
                                                <Editor
                                                    editorState={helpers.getEditorStateFromNotes(studyPerson.notes)}
                                                    readOnly={true}
                                                />
                                            </Box>
                                        </Box>
                                    }
                                 </small>   
                            </Box>
                        </Box>
                    );
                }
            });
        }

        if (which_studies.length == 0) {
            which_studies.push(<Box fontSize={1}>This person has not participated in any studies.</Box>);
        }

        return which_studies;
    }
}

export default PastParticipation;
